module.exports = __webpack_public_path__ + "static/media/logo.c3abc04e.png";